import { Component } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Storage } from '@ionic/storage';
import { ViewController, NavParams } from 'ionic-angular';

import { eGENA_Teilnehmerspezifisches, TEILNEHMERKENNUNG_GENERISCH } from '../../visionet/Teilnehmerspezifisches';
import { eGENA_TeilnehmerInfo, eGENA_TeilnehmerStatus} from '../../visionet//TeilnehmerInfo'
import { MiddlewareService } from '../../services/middleware.service';
import { getErrorString } from '../../visionet/Error';
import { GlobalsSingleton } from '../../app/core/GlobalsSingleton';

import { GlobalConstants } from '../../app/core/GlobalConstants';


@Component({
	templateUrl: 'KlinikkennungEingabePopup.html',
	providers: [
		GlobalsSingleton
	]
})

export class KlinikkennungEingabePopup {


	teilnehmerkennung : string = "";
	teilnehmerkennungLokalisiert : string = "";
	bisherigeTeilnehmerkennung : string = "";
	bisherigeTeilnehmerkennungLokalisiert : string = "";

	feedback : SafeHtml = "";

	constructor(public viewCtrl: ViewController, public navParams: NavParams, public storage: Storage, private middlewareService: MiddlewareService, public sanitizer: DomSanitizer, public globals: GlobalsSingleton) {
		let teilnehmerkennunungUrlParameter : string =  this.navParams.get('teilnehmerkennungAusUrlFuerAutomatischesSetzen');
		if (teilnehmerkennunungUrlParameter != undefined) {
			this.teilnehmerkennung = teilnehmerkennunungUrlParameter;
			this.teilnehmerkennungLokalisiert = teilnehmerkennunungUrlParameter;
			// Die Teilnehmerkennung kommt aus der URL. Wir versuchen ein automatisches submit.
			// Wenn die Teilnehmerkennung korrekt war, wofon wir ausgehen dürfen,
			// schließt sich das popup danach automatisch.
			this.onFormSubmit();
		}
		else {
			// Zunächst die bisherige Teilnehmerkennung ermitteln.
			this.getTeilnehmerdatenFromStorage().then((value : eGENA_Teilnehmerspezifisches) => {
				this.bisherigeTeilnehmerkennung = value.Teilnehmerkennung;
				this.bisherigeTeilnehmerkennungLokalisiert = value.TeilnehmerkennungLokalisiert;
				// Wenn noch keine Teilnehmerkennung eingegeben wurde, ist die bisherige noch gültig.
				if (!this.teilnehmerkennungLokalisiert) {
					this.teilnehmerkennung = this.bisherigeTeilnehmerkennung;
					this.teilnehmerkennungLokalisiert = this.bisherigeTeilnehmerkennungLokalisiert;
				}
			});
		}
	}
	
	
	zeigeGenerischenHinweis() : boolean {
		if (this.teilnehmerkennung.trim().length > 0 && this.teilnehmerkennung != TEILNEHMERKENNUNG_GENERISCH)
			return true;
		return false;
	}


	/**	=== Visionet(sl) ==========
	 *	Wird das Popup einfach geschlossen ohne Submit, dann stellen wir den bisherigen
	 *	Wert der Teilnehmerkennung wieder her
	 */
	close() {
		this.teilnehmerkennung = this.bisherigeTeilnehmerkennung;
		// Fenster einfach schließ0en, nicht zur Startseite gehen
		this.viewCtrl.dismiss({
			goToRoot : false
		});
	}


	/**	=== Visionet(sl) ==========
	 *	Wenn sich die Teilnehmerkennung ändert, muss erst mal überprüft werden ob sie gültig ist.
	 */
	onFormSubmit() {
		let tmpTeilnehmerkennung : string = this.teilnehmerkennung;
		let änderung : boolean = false;

		if (this.teilnehmerkennungLokalisiert !== this.bisherigeTeilnehmerkennungLokalisiert) {
			console.log("geänderte Teilnehmerkennung: " + this.teilnehmerkennungLokalisiert);
			// Die Teilnehmerkennung hat sich gegenüber der zuletzt intern gespeicherten geändert
			// Wurde sie gelöscht, d.h. kehren wir zu einer generischen Version zurück?
			if (this.teilnehmerkennungLokalisiert.length == 0 && this.bisherigeTeilnehmerkennungLokalisiert.trim().length > 0) {
				tmpTeilnehmerkennung = TEILNEHMERKENNUNG_GENERISCH;
				änderung = true;
			}
			else if (this.teilnehmerkennungLokalisiert.length != 8) {
				this.feedback = this.globals.translateHTML('Teilnehmerkennung.genau 8 Ziffern');
			}
			else if (! RegExp('^\\d+$').test(this.teilnehmerkennungLokalisiert)) {
				this.feedback = this.globals.translateHTML('Teilnehmerkennung.ausschließlich Ziffern');
			}
			else {
				tmpTeilnehmerkennung = this.teilnehmerkennungLokalisiert;
				änderung = true;
			}

			if (änderung) {
				// Ist es eine teilnehmerspezifische Variante mit Nummer?
				if (tmpTeilnehmerkennung != TEILNEHMERKENNUNG_GENERISCH) {
					// Die Teilnehmerkennung ist zumindest formal korrekt. Jetzt also die Middleware fragen...
					console.debug("Die Teilnehmerkennung wird zur Überprüfzung an den Server übermittelt...");
					this.middlewareService.checkKennung(tmpTeilnehmerkennung).subscribe((teilnehmerInfo : eGENA_TeilnehmerInfo) => {
						console.debug("Antwort des Servers: " + JSON.stringify(teilnehmerInfo, null, 4));
						if (teilnehmerInfo.Status != undefined) {
							if (teilnehmerInfo.Status != eGENA_TeilnehmerStatus.VERÖFFENTLICHT) {
								// Der Teilnehmer ist noch nicht veröffentlicht aber immerhin gab es eine
								// ordentliche Antwort von der Middleware
								this.feedback = this.sanitizer.bypassSecurityTrustHtml(teilnehmerInfo.Zusatzinformationen);
							}
							else {
								// Alles passt, also die neue Kennung speichern und die zugehörigen Checklisten-Daten abrufen.
								this.speichereTeilnehmerkennungUndDannAbZumStart(tmpTeilnehmerkennung);
							}
						}
						else {
							if (teilnehmerInfo.Zusatzinformationen != undefined) {
								this.feedback = this.sanitizer.bypassSecurityTrustHtml(teilnehmerInfo.Zusatzinformationen);
							}
							else {
								this.feedback = this.sanitizer.bypassSecurityTrustHtml(this.globals.translate('Teilnehmerkennung.Keine verwertbare Antwort des Servers'));
							}
						}
					},
					error => {
						// Fehler beim Abfragen der Middleware
						this.feedback = this.sanitizer.bypassSecurityTrustHtml(getErrorString(error));
					});
				}
				else {
					console.log("Rücksetzen auf generische Teilnehmerkennung");
					// wir kehren zu einer generischen Version zurück
					this.speichereTeilnehmerkennungUndDannAbZumStart(tmpTeilnehmerkennung);
//					this.viewCtrl.dismiss();
				}
			}
		}
		else {
			// Keine Änderung der Teilnehmerkennung, also Popup einfach wieder schließen
			this.viewCtrl.dismiss();
		}
	}


	async getTeilnehmerdatenFromStorage() : Promise<eGENA_Teilnehmerspezifisches> {
		let ret = await this.storage.get(GlobalConstants.STORAGE_KEY_TEILNEHMERSPEZIFISCHES).then((teilnehmerspezifisches : eGENA_Teilnehmerspezifisches) => {
			if (teilnehmerspezifisches) {
				return teilnehmerspezifisches;
			}
		})

		return ret;
	}


	async speichereTeilnehmerkennungUndDannAbZumStart(teilnehmerkennung : string) {
		// Alle Daten samt alter Teilnehmerkennung löschen
		console.info("Nach Eingabe der Teilnehmerkennung '" + teilnehmerkennung + "' die bisherige Daten löschen...");
		this.storage.clear()
		.then(() => {
			// Neue Teilnehmerkennung speichern
			if (teilnehmerkennung != TEILNEHMERKENNUNG_GENERISCH) {
				console.info("Neue Teilnehmerkennung '" + teilnehmerkennung + "' speichern...");
				this.storage.set(GlobalConstants.STORAGE_KEY_AKTUELLE_VERSION, "0")
				.then(() => {
					this.storage.set(GlobalConstants.STORAGE_KEY_TEILNEHMERKENNUNG, teilnehmerkennung)
					.then(() => {
						// Zurück auf Start. Dort werden dann alle Daten neu geladen
						console.info("Springe zur Startseite. Dort werden alle Daten wegen des Wechsels der Teilnehmerkennung neu geladen...");

						this.viewCtrl.dismiss({
							goToRoot : true
						});
					})
		
				})
			}
			else {
				this.viewCtrl.dismiss({
					goToRoot : true
				});
			}
		});
	}

}



// WEBPACK FOOTER //
// ./src/components/popups/KlinikkennungEingabePopup.ts